<template>
  <v-main class="page-guide page-guide-select">
    <AppBar :hide-back="isGoMain" hide-background/>
    <v-layout fill-height column>

      <v-container class="pb-0" fluid>
        <div class="account-title-block">
          <h3 class="tit">
            <span class="tit-point">가이드 캐릭터</span> 선택
          </h3>
          <p class="desc">
            <!--          가이드는 여행을 함께하는 마음 전문가예요.<br>-->
            <!--          1:1채팅으로 상담대화(찐한 대화)를 나누고<br>-->
            <!--          여행 중 수행한 미션에 대해 피드백 해줘요.-->
            가이드는 여행을 함께하는 마음전문가예요.<br>
            1:1채팅으로 원하는 주제에 대해 상담대화를 나누고<br>
            여행 중 수행한 미션에 대해 피드백 해줘요.
          </p>
        </div>
      </v-container>
      <div class="guide-select-wrap">
        <Flicking :options="flickingOptions" class="flicking-character">
          <div v-for="(item,index) in guides"
               :key="index"
               class="flicking-character-item"
          >
            <div class="character"
                 :class="{'select' : select === index}"
                 @click="select = index">
              <div class="character-img">
                <v-img :src="getImage(item.character)"
                       contain aspect-ratio="1/1"
                       width="auto"
                       max-height="calc(calc(var(--vh, 1vh) * 20)"
                       class="rounded"></v-img>
              </div>
              <p class="character-tit">
                <b class="mx-1" v-for="(title, index) in item.title" :key="index">#{{ title }}</b>
              </p>
              <p class="character-txt">{{ item.text }}</p>
              <p class="character-tag">
                <span class="mx-1" v-for="(tag, index) in item.tag" :key="index">#{{ tag }}</span>
              </p>
            </div>
          </div>
        </Flicking>
      </div>
      <v-footer app color="white" class="content-footer">
        <div class="footer-btns">
          <BlackBtn x-large str="선택하기" @click="next" :disabled="select === null"></BlackBtn>
          <!--        <v-btn v-if="isGoMain" block text height="48" depressed @click="movePage('/')">다음에 등록하기</v-btn>-->
        </div>
      </v-footer>
    </v-layout>
  </v-main>
</template>
<script>
import store from '@/store'
import { mixinRemote } from '@/mixins'
import BlackBtn from "@/components/btns/BlackBtn";

export default {
  components: {
    BlackBtn
  },
  mixins: [mixinRemote ],
  data: () => ({
    select: null,
    isFir: true,
    isChatting: false,
    hasPreviousRealtalk: false,
    flickingOptions: {
      bound: true,
      panelsPerView: 1.1,
      preventClickOnDrag: false,
      interruptable: false
    }
  }),
  computed: {
    isGoMain() {
      // 2022-11-29 가이드에서는 진입 후 이탈 불가하도록
      // return this.$route.query.m === '1'
      return true
    }
  },
  async created() {
    await this.getUseOrdDtlNoGuide();
    await this.findRealtalk();
  },
  methods: {
    next() {
      //TODO.
      this.$router.push({
        name: '찐한 일정 선택',
        query: {
          chaImgNo: this.select,
          hasPreviousRealtalk: this.hasPreviousRealtalk
        }
      });
    },
    async getUseOrdDtlNoGuide() {  // 유저 티켓 사용 API
      await store.dispatch('getUseOrdDtlNoGuide')
          .then(res => {
            if (res.success) {
              if (res.data == null) {
                //this.movePage('/');
              }
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {

          })
    },
    async findRealtalk() {
        await store.dispatch('findRealtalk', this.$_payload('so', [{}]))
        .then(res => {
            if(res.data.message.length !== null){
                this.isFir = false;
            }
            this.isChatting = res.data.isChat;
            //Note. 14954 SR 반영
            this.hasPreviousRealtalk = !!res.data.realTalkMasterNo;

            let apprStatus = res.data.apprStatus // 가이드 활동여부 값 : 2 일때 '활동승인' 상태임
            if (!(this.isChatting&&this.isFir) && apprStatus === 2){
              // 종료일로부터 90일 이후에는 유지하기 얼럿 노출 x - #10874
              if (res.data.isKeepingGuide && this.$route.query.isKeepingGuide !== 'N') {

                this.$confirm('기존 가이드로 자동배치됩니다. <br/> 변경하시겠어요?', {
                  persistent: false,
                  showClose: false,
                  actions: {
                    false: {text: '변경하기'},
                    true: {text: '유지하기', color: '#ff4a4a'}
                  }
                }).then(result => {
                  if (result){
                    this.$router.push({
                      name: '찐한 일정 선택',
                      query: {
                        bfGuideNo: this.bfGuideNo,
                        bfChaImgNo: this.bfChaImgNo,
                        hasPreviousRealtalk: this.hasPreviousRealtalk
                      }
                    })
                  } else {
                    this.$router.push({name: '가이드 선택', params: {hasPreviousRealtalk: this.hasPreviousRealtalk}
                    })
                  }
                })
              }
            }
            this.bfGuideNo = res.data.guideNo;
            this.bfChaImgNo = res.data.chaImgNo;
        })
        .catch(error => {
            console.error(error)
            this.memberStepApplCnt = 0;
        })
        .finally(() => {
        })

    },
  }
}
</script>
